import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { Company } from 'src/app/domains/companies/models';
import { ConnectionDetails, ConnectionEquipment, ConnectionEquipmentInfo, ConnectionModemEquipment, ConnectivityCatalogType } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { AddConnectivityEquipmentPopupComponent } from '../add-connectivity-equipment-popup/add-connectivity-equipment-popup.component';
import { CompanyConnectivityEquipmentInfoPopupComponent } from '../company-connectivity-equipment-info-popup/company-connectivity-equipment-info-popup.component';
import { EditConnectivityEquipmentPopupComponent } from '../edit-connectivity-equipment-popup/edit-connectivity-equipment-popup.component';

@Component({
  selector: 'gdp-company-connectivity-equipment',
  templateUrl: './company-connectivity-equipment.component.html',
  styleUrls: ['./company-connectivity-equipment.component.scss']
})
export class CompanyConnectivityEquipmentComponent implements OnInit {
  public equipmentList: ConnectionEquipment[];
  public loading: boolean = false;
  public company: Company = null;
  public connection: ConnectionDetails;
  public showErrorMsg: boolean = false;
  @Output() onEditEquipment: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private connectivityService: ConnectivityService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private notification: NotificationService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent.data.subscribe(
      (d: { resolved: { connection: ConnectionDetails, company: Company } }) => {
        this.connection = d.resolved.connection;
        this.company = d.resolved.company
      }
    );
    this.getConnectionEquipment();
  }

  private getConnectionEquipment(): void {
    this.loading = true;
    this.connectivityService.getEquipmentByConnectionId(this.connection.id)
      .subscribe((res: ConnectionEquipment[]) => {
        this.equipmentList = res;
        this.showErrorMsg = false;
        this.loading = false;
      }, () => {
        this.showErrorMsg = true;
        this.loading = false;
      });
  }

  public openEquipmentInfoPopup(equipment: ConnectionEquipment): void {
    const modal = this.modalService.open(CompanyConnectivityEquipmentInfoPopupComponent, {
      size: 'lg'
    });

    modal.componentInstance.equipmentInfo = equipment;
  }

  public openAddEquipmentPopup() {
    const modal = this.modalService.open(AddConnectivityEquipmentPopupComponent, {
      size: 'lg'
    });

    modal.componentInstance.connectionId = this.connection.id;
    modal.componentInstance.company = this.company;
    modal.componentInstance.onCreateEquipment.pipe(take(1)).subscribe(() => {
      this.getConnectionEquipment();
      this.notification.success('company.connectivity.details.equipment.notifications.success.added');
    });
  }

  public openEditEquipmentInfoPopup(equipment: ConnectionEquipment) {
    const modal = this.modalService.open(EditConnectivityEquipmentPopupComponent, {
      size: 'lg'
    });

    modal.componentInstance.connectionId = this.connection.id;
    modal.componentInstance.equipmentInfo = equipment;
    modal.componentInstance.company = this.company;
    modal.componentInstance.onEditEquipment.pipe(take(1)).subscribe(() => {
      this.onEditEquipment.emit();
      this.getConnectionEquipment();
      this.notification.success('company.connectivity.details.equipment.notifications.success.updated');
    })
  }
}
